import { render } from "./crm-credentilas.vue?vue&type=template&id=2282f76e"
import script from "./crm-credentilas.vue?vue&type=script&lang=js"
export * from "./crm-credentilas.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__